module.exports = __webpack_public_path__ + "static/img/v4.d191a0d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/vip/v4.svg
// module id = 3aRH
// module chunks = 0